import axios from 'axios'
import { IFeatureUpdate } from '@src/types/featureUpdates'
import { Environment } from '@src/types/realmSettings.types'
import { createOptimizedAPI } from '.'
import { realmSettingsApi } from './apiModuleInstances'

interface IFeatureUpdatesApi {
  getFeatures(userTrackingId: string, offset?: number, languageId?: string): Promise<{data: IFeatureUpdate}>;
  markAsRead(userTrackingId: string, featureIds: string[]): Promise<void>;
}

interface IConfig { isEnabled: boolean; realmId: string; url: string; }

export const WHATS_NEW_LIMIT = 11
export const MAX_UNREAD_COUNT = 10

const config = async (): Promise<IConfig> => {
  const { data: { general: { environment }, metadata: { realm_id: realmId }, whats_new: { enabled, url } } } = await realmSettingsApi.cached.get()
  return {
    isEnabled: enabled && environment !== Environment.ONPREM && !window.Cypress,
    realmId,
    url: `${url}/feature-updates`
  }
}

const featureUpdatesApi: IFeatureUpdatesApi = {
  async getFeatures(userTrackingId, offset = 0, languageId = 'en') {
    const params = {
      userId: userTrackingId,
      limit: WHATS_NEW_LIMIT,
      offset,
      languageId
    }
    const { isEnabled, url } = await config()
    return isEnabled
      ? axios.get(url, { params })
      : { data: { updates: [], lastSeenUser: (new Date()).toISOString() } }
  },
  async markAsRead(userTrackingId, featureIds) {
    const { isEnabled, realmId, url } = await config()
    // The realm is required: what's new refuses read state it cannot attribute
    // to a realm, so that it can be migrated and erased per realm.
    const params = {
      userId: userTrackingId,
      realmId,
      featureIds: featureIds.join(',')
    }
    return isEnabled
      ? axios.post(`${url}/mark-as-read`, null, { params })
      : Promise.resolve()
  }
}

export default {
  ...featureUpdatesApi,
  ...createOptimizedAPI(featureUpdatesApi)
}
